import ErrorView from '@components/ErrorView';
import './index.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';

// The API sends the provider's own value (PLANNING_CENTER); the events backend
// sent a short name, and old links are still worth reading.
function providerName(provider: string | null) {
  switch (provider) {
    case 'PLANNING_CENTER':
    case 'planning-center':
    case 'pco':
      return 'Planning Center';
    case 'SMART_WAIVER':
    case 'smart-waiver':
      return 'Smartwaiver';
    default:
      return 'provider';
  }
}

// Machine-readable codes from the callback, so the Hub renders its own copy
// rather than surfacing the API's prose.
function reasonCopy(reason: string | null, name: string) {
  switch (reason) {
    case 'organization_mismatch':
      return `That ${name} organization is different from the one already connected. Connect the original organization, or disconnect first.`;
    case 'missing_organization':
      return `We couldn't read an organization from that ${name} account.`;
    case 'access_denied':
      return `The ${name} connection was declined.`;
    case 'missing_parameters':
    case 'unsupported_flow':
      return `${name} sent us back without everything we needed. Please try again.`;
    default:
      return `Failed to connect with ${name}.`;
  }
}

export default function ConnectionsRedirectPage() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const provider = searchParams.get("provider");
  const success = searchParams.get("success") == "true";
  const reason = searchParams.get("reason");

  const name = providerName(provider);

  if (!success) {
    return <ErrorView error={reasonCopy(reason, name)}
      buttonText='Continue'
      buttonAction={() => navigate('/connections')} />
  }

  return <div className="redirect-success-view">
    <h1>✅</h1>
    <h1>Successfully Connected!</h1>
    <p>You've successfully connected with {name}.</p>

    <a href="#" onClick={() => navigate('/connections')}>Continue</a>
  </div>
}
